<script setup lang="ts">
defineProps<{
  message: string
  variant?: 'info' | 'success' | 'danger' | 'warning'
}>()
</script>

<template>
  <div
    v-if="message"
    class="mb-3 rounded-md border px-3 py-2 text-sm"
    :class="{
      'border-info/30 bg-info-light text-info': variant === 'info' || !variant,
      'border-success/30 bg-success-light text-success': variant === 'success',
      'border-danger/30 bg-danger-light text-danger': variant === 'danger',
      'border-warning/30 bg-warning-light text-warning': variant === 'warning',
    }"
    role="alert"
  >
    {{ message }}
  </div>
</template>
